import {Component, OnInit, HostListener, Inject, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {ApiService, SoftwareProperty, SoftwaresList, Vps} from '../../../api/api.service';
import {User} from '../../../User';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from '../../../auth.service';
import {HeaderService} from '../header.service';
import {SidebarServiceService} from '../../shared/sidebar/sidebar-service.service';
import {timer} from 'rxjs';
import {environment} from '../../../../environments/environment';
declare var $: any;

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit, AfterViewInit {

  changes = true;
  updating = false;
  user: User;
  userAccess: UserAccessSoftwares[];
  private softwareAlreadyTried: { [name: string]: boolean } = {};
  addSoftware: string;
  logOutClicked = false;
  errorStateIdConto = false;
  idContoError: number;
  inizialized = false;
  softwares: SoftwaresList;
  vpsList: Vps[];
  oneLicenceIsActive: boolean;
  vpsChanges = true;
  errorVpsConto = false;

  closeNavEvent: boolean

  constructor(public router: Router,
              @Inject(DOCUMENT) private document: Document,
              private activatedRoute: ActivatedRoute,
              private api: ApiService,
              private cookieService: CookieService,
              private authService: AuthService,
              private headerService: HeaderService,
              private sidebarServiceService: SidebarServiceService
  ) {
    this.loadScript('admin-style.js');

    headerService.itemClicked.subscribe(ev => {
      this.showMobileMenu = false
    })

    this.oberserableTimer()

  }

  oberserableTimer() {
    const source = timer(0, 10);
    const abc = source.subscribe(val => {
      this.changeWidth(this.side.nativeElement)

    });
  }


  public isCollapsed = false;

  public innerWidth: any;
  public defaultSidebar: any;
  public showMobileMenu = false;
  public expandLogo = false;

  options = {
    sidebartype: 'full',
  };

  console = console

  loadScript(scriptUrl) {
    const script = document.createElement('script');
    script.src = scriptUrl;
    document.body.appendChild(script);
  }

  @ViewChild('side') side: ElementRef

  Logo(elem) {
    this.expandLogo = !this.expandLogo
    this.changeWidth(elem)
  }

  changeWidth(elem) {
    if (elem.offsetWidth < 250)
      this.sidebarServiceService.width.emit(elem.offsetWidth)
    else if(elem.offsetWidth>500)
      this.sidebarServiceService.width.emit(64)
    else if(elem.offsetWidth>= 250)
      this.sidebarServiceService.width.emit(250)
  }

  oneLicenceActive() {
    this.userAccess.forEach(res => {
      if (res.activation)
        this.oneLicenceIsActive = true;
    });
  }

  logout() {
    this.cookieService.delete( 'email');
    this.cookieService.delete( 'password');
    this.cookieService.deleteAll('/','assetstore.assetx.it')
    this.cookieService.deleteAll()
    console.log('log out')
    this.authService.doSignOutUser();
    window.location.replace(environment.host+'login')
  }

  getSoftwaresTried() {
    for (let acc of this.userAccess) {
      this.softwareAlreadyTried[acc.software_name] = true;
    }
    for (let acc of this.userAccess) {
      this.api.checkSoftwareTried(this.user.email, acc.software_name).subscribe(resp => {
        if (resp != undefined) {
          this.softwareAlreadyTried[acc.software_name.toLowerCase()] = resp.result;
        }
      });
    }
  }

  ngOnInit() {
    this.user = this.activatedRoute.snapshot.data.user;
    this.softwares = this.activatedRoute.snapshot.data.softwares;
    this.vpsList = this.activatedRoute.snapshot.data.vps;
    this.userAccess = JSON.parse(atob(this.user.software_access));
    this.getSoftwaresTried();
    this.oneLicenceActive();


    this.defaultSidebar = this.options.sidebartype;
    this.handleSidebar();

    this.inizialized = true;

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleSidebar();
  }

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    switch (this.defaultSidebar) {
      case 'full':
        if (this.innerWidth < 1170) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;
      default:
    }
  }

  ngAfterViewInit(): void {
    this.changeWidth(this.side.nativeElement)
  }
}

export interface UserAccessSoftwares {
  id_conto: string,
  software_name: string,
  activation: boolean,
  chat_id: string,
  properties?: SoftwareProperty[]
}
